export const CARE_MAIL_WINDOW_NAME = "performance-care-mail";
export const ADMIN_SHIFT_PLAN_WINDOW_NAME = "performance-care-shift-plan";

export function mailWindowPath(basePath, params = {}) {
  const query = new URLSearchParams();
  if (params.connection) query.set("connection", params.connection);
  if (params.message) query.set("message", params.message);
  if (params.focusMessage) query.set("focus_message", params.focusMessage);
  if (params.keepUnread) query.set("keep_unread", "1");
  if (params.quoteService) query.set("quote_service", params.quoteService);
  if (params.quoteProvider) query.set("quote_provider", params.quoteProvider);
  if (params.staffDocument) query.set("staff_document", params.staffDocument);
  if (params.staffDocumentName) query.set("staff_document_name", params.staffDocumentName);
  if (params.staffManagerName) query.set("staff_manager_name", params.staffManagerName);
  if (params.staffPeriod) query.set("staff_period", params.staffPeriod);
  if (params.staffEvidence) query.set("staff_evidence", params.staffEvidence);
  if (params.locale) query.set("lang", params.locale);
  const suffix = query.toString();
  return `${basePath}${suffix ? `?${suffix}` : ""}`;
}

export function careMailWindowPath(params = {}) {
  return mailWindowPath("/care/mail", params);
}

export function adminMailWindowPath(params = {}) {
  return mailWindowPath("/admin/mail", params);
}

export function openWorkspaceWindow(path, targetName, hostWindow = window) {
  const availableWidth = Number(hostWindow.screen?.availWidth) || 1440;
  const availableHeight = Number(hostWindow.screen?.availHeight) || 1000;
  const width = Math.min(1320, Math.max(960, availableWidth - 96));
  const height = Math.min(960, Math.max(720, availableHeight - 72));
  const left = Math.max(0, Math.round((availableWidth - width) / 2));
  const top = Math.max(0, Math.round((availableHeight - height) / 2));
  const features = `popup=yes,width=${width},height=${height},left=${left},top=${top},resizable=yes,scrollbars=yes`;
  const popup = hostWindow.open(path, targetName, features);
  if (popup) {
    try {
      if (popup.location?.href === "about:blank") popup.location.replace(path);
    } catch {
      // The browser may isolate the new window immediately; the original URL still applies.
    }
    popup.focus?.();
    return popup;
  }
  return hostWindow.open(path, "_blank", "noopener,noreferrer");
}

export function openMailWindow(path, hostWindow = window) {
  return openWorkspaceWindow(path, CARE_MAIL_WINDOW_NAME, hostWindow);
}

export function openCareMailWindow(params = {}, hostWindow = window) {
  return openMailWindow(careMailWindowPath(params), hostWindow);
}

export function openAdminMailWindow(params = {}, hostWindow = window) {
  return openMailWindow(adminMailWindowPath(params), hostWindow);
}

export function openAdminShiftPlanWindow(hostWindow = window) {
  return openWorkspaceWindow("/admin/shift-plan", ADMIN_SHIFT_PLAN_WINDOW_NAME, hostWindow);
}
